export class DriverBonusLevel {
  id: number = -1;

  name: string = '';
  value: number = 0;

  createdAt: string = '';
  updatedAt: string = '';
}
